module.exports = __webpack_public_path__ + "static/media/dinosaur(18).3c11b44b.PNG";